export default __webpack_public_path__ + "static/media/bank_card_vertical.51b1d47e.svg";